export { ProductDetailsPage as default } from '@moonpig/web-explore-find'
